// extracted by mini-css-extract-plugin
export default {"container":"DeviceCard_container__k55Zn","card":"DeviceCard_card__ZFxvU","item":"DeviceCard_item__zFr2n"};